import React from 'react';
import './Input.css';

const Input = ({ label, name, value, onChange, maxLength, type = "text" }) => {
  // const handleInput = (e) => {
  //   if (type === 'tel') {
  //     const newValue = e.target.value.replace(/\D/g, ''); // Allow only digits for mobile number
  //     e.target.value = newValue;
  //   }
  // };

  const handleGSTINInput = (e) => {
    const newValue = e.target.value.toUpperCase(); // Convert to uppercase
    if (/^[0-9A-Z]*$/.test(newValue)) { // Check if only alphanumeric characters are entered
      e.target.value = newValue;
      onChange(e); // Call onChange function passed from props
    }
  };

  return (
    <div className="input-group">
      <label>{label}</label>
      <input
        type={type === 'gstin' ? 'text' : type} // Treat GSTIN input as text
        name={name} 
        value={value} 
        onChange={type === 'gstin' ? handleGSTINInput : onChange} // Handle GSTIN input separately
        maxLength={maxLength}
        pattern={type === 'tel' ? "[6-9]{1}[0-9]{9}" : (type === 'gstin' ? "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$" : undefined)} // Pattern for Indian mobile numbers and GSTIN
        title={type === 'tel' ? "Please enter a valid 10-digit Indian mobile number starting with 6-9" : (type === 'gstin' ? "Please enter a valid GSTIN number" : undefined)} // Title for tooltip message
        className="input-field"
        required
      />
    </div>
  );
};

export default Input;
